import AddressSearch from '../../Components/AddressSearch/AddressSearch';
import AddressZipSearch from '../../Components/AddressSearch/AddressZipSearch';

document.addEventListener('DOMContentLoaded', _ => {
    AddressZipSearch.initAll();
    AddressSearch.initAll();
});